import React from 'react'
import styled, { css } from 'styled-components'

export const Backdrop = ({ click, desktop, show }: BackdropProps) => {
  return <DimBackground onClick={click} desktop={desktop} show={show} />
}

type BackdropProps = {
  click: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void | undefined
  desktop?: boolean
  show?: boolean
}

const DimBackground = styled.div<{ desktop?: boolean; show?: boolean }>`
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: rgba(34, 34, 34, 0.76);
  overflow: hidden;
  opacity: 0;
  z-index: 99999;
  transition: opacity 0.3s ease 0.1s, z-index 0s ease 0.3s,
    visibility 0s ease 0.3s;
  visibility: hidden;
  pointer-events: none;

  ${(props) =>
    props.show &&
    css`
      pointer-events: all;
      opacity: 1;
      transition: opacity 0.3s ease 0.1s, z-index 0s ease 0s,
        visibility 0s ease 0s;
      visibility: visible;
      ${!props.desktop &&
      css`
        @media (min-width: ${({ theme }) => theme.breakpoints.md.min}) {
          display: none;
        }
      `}
    `};
`
